module.exports = __webpack_public_path__ + "r-v3/img/screen_decrease.642f13b8.svg";